import Image from "next/image";
import Link from "next/link";
import { FC, useState } from "react";
import Button from "~/components/Button";
import ContactUsModal from "~/components/ContactUsModal";
import Icon from "~/components/Icon";
import styles from "./EnterpriseFeatureBox.module.scss";

const features = [
  "Got Everything from Business",
  "Custom AI Training Model",
  "SAML SSO",
  "Customized AI Model",
  "24/7 Support",
  "Specific solution for Enterprise",
  "99.9% SLA commitment",
  "dedicated infrastructure",
];

const EnterpriseFeatureBox: FC = () => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section
      className={styles.enterprise_feature_box}
      data-aos="fade-up"
      id="enterprise"
    >
      <div className={styles.box}>
        <div className={styles.left}>
          <Image src="/images/social.png" alt="Social" fill />
        </div>
        <div className={styles.right}>
          <div className="flex flex-col gap-1">
            <h3 className={styles.title}>Enterprise</h3>
            <p className={styles.description}>
              The Global use, no limit, no border of scale. Make your business
              could operate 24/7.
            </p>
          </div>
          <div className={styles.line}></div>
          <div className={styles.features}>
            {features.map((feature, index) => (
              <div className={styles.feature_item} key={index}>
                <Icon name="tick-circle" color="#733FE7" />
                <p className={styles.text}>{feature}</p>
              </div>
            ))}
          </div>
          <div className={styles.button}>
            <p className={styles.text}>Let’s talk</p>
            <Button
              type="outline"
              variant="secondary"
              onClick={() => setOpenModal(true)}
            >
              Get Started
            </Button>
          </div>
          <Link href="/enterprise" className={styles.link}>
            <Icon name="arrow-right-1" color="#727272" />
          </Link>
        </div>
      </div>

      <ContactUsModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
      />
    </section>
  );
};

export default EnterpriseFeatureBox;
